import { PlusCircle } from "lucide-react";
import useTranslations from "@/shared/lang/useTranslations";

type AddAccountPlaceholderCardProps = {
  label?: string;
  onClick?: () => void;
};

export const AddAccountPlaceholderCard = ({
  label,
  onClick,
}: AddAccountPlaceholderCardProps) => {
  const { t } = useTranslations("accountsWallets");
  const displayLabel = label ?? t("placeholder_new_account");
  return (
    <button
      type="button"
      onClick={onClick}
      className="group w-full bg-slate-50/50 dark:bg-zinc-800/50 rounded-xl border-2 border-dashed border-slate-200 dark:border-zinc-600 p-8 flex flex-col items-center justify-center gap-2 text-slate-400 dark:text-zinc-500 hover:border-green-500 dark:hover:border-green-400 hover:text-green-500 dark:hover:text-green-400 transition-colors cursor-pointer"
    >
      <PlusCircle className="h-10 w-10" />
      <p className="text-xs font-bold uppercase tracking-widest">{displayLabel}</p>
    </button>
  );
};
